import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BatteryFilterType, IProjectsDataClient, OriginBatteryDto, ProjectsDataClient } from "app/ApiClient";
import { LoadingState } from "types";
import { DEFAULT_BATTERIES, initialBatteriesState } from "./batteriesState";

const projectDataClient: IProjectsDataClient = new ProjectsDataClient(process.env.REACT_APP_API_URL);

export const getBatteriesByProjectId = createAsyncThunk(
  "batteries/getBatteries",
  async (
    {
      projectId,
      versionId,
      stackId,
      modificationId,
    }: {
      projectId: number;
      versionId: string;
      stackId?: number;
      modificationId?: number;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await projectDataClient.getBatteries(projectId, versionId, stackId, modificationId);
      // ???
      return [
        ...result.filter((row) => DEFAULT_BATTERIES.includes(String(row.name))),
        ...result.filter((row) => !DEFAULT_BATTERIES.includes(String(row.name))),
      ];
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const batteriesSlice = createSlice({
  name: "batteries",
  initialState: initialBatteriesState,
  reducers: {
    resetBatteries: () => initialBatteriesState,
    setBatterySearchText: (state, { payload }: PayloadAction<string | undefined>) => {
      state.searchText = payload;
    },
    setBatteryFilterTypes: (state, { payload }: PayloadAction<BatteryFilterType[]>) => {
      state.batteryFilterTypes = payload;
    },
    setBatteries: (state, { payload }: PayloadAction<OriginBatteryDto[]>) => {
      state.data = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBatteriesByProjectId.pending, (state) => {
      state.data = [];
      state.loading = LoadingState.pending;
    });
    builder.addCase(getBatteriesByProjectId.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.loading = LoadingState.succeed;
    });
  },
});
export const { resetBatteries, setBatterySearchText, setBatteryFilterTypes, setBatteries } = batteriesSlice.actions;
export default batteriesSlice.reducer;
